export default "__VITE_ASSET__BMjGveLj__"